<div class="client-container d-flex flex-column webinar-series-detail-page">
    @if (isLoading) {
        <div class="webinar-series-detail__loading">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
    } @else if (series) {
        <mat-card class="cardPlain">
            <mat-card-header>
                <div class="section-header d-flex flex-col gap-4">
                    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
                    <h1 class="m-0 f-w-500">{{ series.title }}</h1>
                    <p class="m-0 help-text">
                        {{ formatSeriesRule(series) }} · stored timezone {{ series.timezone }}
                    </p>
                </div>
                <span class="spacer"></span>
                <button (click)="refresh()" class="d-inline-flex align-items-center gap-6" color="primary" mat-stroked-button type="button">
                    <mat-icon>refresh</mat-icon>
                    Refresh
                </button>
            </mat-card-header>

            <mat-card-content class="d-flex flex-col gap-24">
                <section class="series-summary-grid">
                    <div class="summary-item">
                        <span class="label">Occurrences</span>
                        <span class="value">{{ series.occurrenceCount }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Starts</span>
                        <span class="value">{{ series.recurrence?.startsOn || 'TBA' }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Duration</span>
                        <span class="value">{{ series.recurrence?.durationMinutes || 0 }} min</span>
                    </div>
                    <div class="summary-item">
                        <span class="label">Template provider</span>
                        <span class="value">{{ series.template.provider | titlecase }}</span>
                    </div>
                </section>

                @if (series.nextOccurrence) {
                    <section class="d-flex flex-col gap-8">
                        <h2 class="m-0 f-s-18 f-w-600">Next occurrence</h2>
                        <p class="m-0 text-gray-100">
                            {{ series.nextOccurrence.title }} · {{ series.nextOccurrence.localStartDate }}
                            {{ series.nextOccurrence.localStartTime }} {{ series.timezone }}
                        </p>
                        <div>
                            <button (click)="openOccurrence(series.nextOccurrence)" color="primary" mat-stroked-button type="button">
                                <mat-icon>open_in_new</mat-icon>
                                Open occurrence
                            </button>
                        </div>
                    </section>
                }

                <section class="d-flex flex-col gap-12">
                    <div class="section-header">
                        <h2 class="m-0 f-s-18 f-w-600">Generated occurrences</h2>
                        <p class="m-0 text-gray-100 f-s-14">
                            Occurrences are normal webinar sessions with isolated registrations, chat, and engagement state.
                        </p>
                    </div>
                    @if (series.occurrences?.length) {
                        <div class="table-responsive">
                            <table [dataSource]="series.occurrences || []" class="webinars-table" mat-table>
                                <ng-container matColumnDef="index">
                                    <th *matHeaderCellDef mat-header-cell>#</th>
                                    <td *matCellDef="let item" mat-cell>{{ item.occurrenceIndex }}</td>
                                </ng-container>

                                <ng-container matColumnDef="title">
                                    <th *matHeaderCellDef mat-header-cell>Occurrence</th>
                                    <td *matCellDef="let item" mat-cell>
                                        <div class="title-cell">
                                            <span class="title">{{ item.title }}</span>
                                            <span class="slug f-s-12 text-gray-100">{{ item.slug }}</span>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="localStart">
                                    <th *matHeaderCellDef mat-header-cell>Local start</th>
                                    <td *matCellDef="let item" mat-cell>
                                        {{ item.localStartDate }} {{ item.localStartTime }} {{ item.timezone || series.timezone }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="utcStart">
                                    <th *matHeaderCellDef mat-header-cell>UTC start</th>
                                    <td *matCellDef="let item" mat-cell>{{ formatDateTime(item.scheduledAt) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="status">
                                    <th *matHeaderCellDef mat-header-cell>Status</th>
                                    <td *matCellDef="let item" mat-cell>{{ item.occurrenceStatus || 'scheduled' }}</td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th *matHeaderCellDef mat-header-cell>Actions</th>
                                    <td *matCellDef="let item" mat-cell>
                                        <button (click)="openOccurrence(item)" color="primary" mat-stroked-button type="button">
                                            Open
                                        </button>
                                    </td>
                                </ng-container>

                                <tr *matHeaderRowDef="occurrenceColumns" mat-header-row></tr>
                                <tr *matRowDef="let row; columns: occurrenceColumns" mat-row></tr>
                            </table>
                        </div>
                    } @else {
                        <div class="d-flex flex-col align-items-center gap-8 p-y-24 text-center">
                            <mat-icon color="accent">event_busy</mat-icon>
                            <p class="m-0 text-gray-100">No generated occurrences.</p>
                        </div>
                    }
                </section>
            </mat-card-content>
        </mat-card>
    }
</div>
